import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type SubscribeToLocationByIdSubscriptionVariables = Types.Exact<{
  locationId: Types.Scalars['bigint']['input'];
  customerId: Types.Scalars['bigint']['input'];
}>;


export type SubscribeToLocationByIdSubscription = { __typename?: 'subscription_root', locations: Array<{ __typename?: 'locations', id: number, active: number, address?: string | null, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, createdat?: string | null, customer_id?: number | null, email?: string | null, favorite: boolean, latitude?: number | null, longitude?: number | null, name?: string | null, nickname?: string | null, phone?: string | null, place_id?: string | null, region_id?: number | null, timezone?: string | null, tookan_id?: number | null, type: string, updatedat?: string | null, customer?: { __typename?: 'customers', active: number, address?: string | null, config?: object | null, email?: string | null, id: number, name?: string | null, phone?: string | null, createdat?: string | null, updatedat?: string | null } | null }> };


export const SubscribeToLocationByIdDocument = gql`
    subscription subscribeToLocationById($locationId: bigint!, $customerId: bigint!) {
  locations(where: {id: {_eq: $locationId}, customer_id: {_eq: $customerId}}) {
    id
    active
    address
    address_line_one
    address_line_two
    city
    state
    zip_code
    createdat
    customer_id
    customer {
      active
      address
      config
      email
      id
      name
      phone
      createdat
      updatedat
    }
    email
    favorite
    latitude
    longitude
    name
    nickname
    phone
    place_id
    region_id
    timezone
    tookan_id
    type
    updatedat
  }
}
    `;

/**
 * __useSubscribeToLocationByIdSubscription__
 *
 * To run a query within a React component, call `useSubscribeToLocationByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToLocationByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToLocationByIdSubscription({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useSubscribeToLocationByIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToLocationByIdSubscription, SubscribeToLocationByIdSubscriptionVariables> & ({ variables: SubscribeToLocationByIdSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToLocationByIdSubscription, SubscribeToLocationByIdSubscriptionVariables>(SubscribeToLocationByIdDocument, options);
      }
export type SubscribeToLocationByIdSubscriptionHookResult = ReturnType<typeof useSubscribeToLocationByIdSubscription>;
export type SubscribeToLocationByIdSubscriptionResult = Apollo.SubscriptionResult<SubscribeToLocationByIdSubscription>;